import { Permission, permissionSchema } from '@/backend/features/authentication/shared';
import { useTranslation } from '@/ui/hooks';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Tooltip } from '@mui/material';
import React from 'react';

const permissionIcons = {
    download: <FileDownloadOutlinedIcon />,
    upload: <FileUploadOutlinedIcon />,
    'change-settings': <SettingsOutlinedIcon />,
    'manage-users': <PeopleOutlinedIcon />,
};

export const PermissionIcons: React.FC<{ permissions: Permission[] }> = ({ permissions }) => {
    const { t } = useTranslation();
    return (
        <>
            {permissionSchema.options
                .filter((permission) => permissions.includes(permission))
                .map((permission) => (
                    <Tooltip key={permission} title={t(`permissionEnum.${permission}`)}>
                        {permissionIcons[permission]}
                    </Tooltip>
                ))}
        </>
    );
};
